import React from 'react'
import { Modal } from 'antd'
import BudgetLineForm from './BudgetLineForm'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'

function BudgetLineModal(props) {
  const {
    visible,
    modalType,
    object: budget,
    submitting,
    removing,
    formRef,
    onCancel,
    update,
    submit,
    remove,
    isUpdatable,
  } = props
  return (
    <Modal
      visible={visible}
      title={modalType === 'new' ? 'Add Budget' : 'Edit Budget'}
      onCancel={onCancel}
      destroyOnClose={true}
      confirmLoading={submitting}
      footer={
        <FooterButtons
          visible={isUpdatable}
          remove={remove}
          removing={removing}
          submit={submit}
          update={update}
          submitting={submitting}
          title={'BudgetLine'}
          isNew={modalType === 'new'}
          isEdit={modalType !== 'new'}
        />
      }
      width={'95%'}>
      <BudgetLineForm ref={formRef} {...props} />
    </Modal>
  )
}

BudgetLineModal.propTypes = {}
BudgetLineModal.defaultProps = {}

export default BudgetLineModal
